import { Rule } from "pages/Rules/common/types";
import { SectionChanges } from "../types";
import { compareSection } from "./compare";
import { sectionConfigs } from "./sections";

type SectionValues = Record<string, unknown> | null;

/**
 * Runs every section over both rules and keeps the ones that changed. This is
 * the whole diff the dialog displays; it is computed once, before opening.
 */
export function getChanges(
  savedRule: Rule,
  currentRule: Rule
): SectionChanges[] {
  const results: SectionChanges[] = [];

  for (const config of sectionConfigs) {
    const saved = config.selector(savedRule) as SectionValues;
    const current = config.selector(currentRule) as SectionValues;
    const properties = compareSection(saved, current, config.properties);

    if (properties.length > 0) {
      results.push({ section: config.section, properties });
    }
  }

  return results;
}
